<ion-content>
  <div class="image-container">
    <div class="image-wrapper">
      <div>
        <video
          #videoPlayer
          *ngIf="!resize"
          class="full-width full-height iframe"
          preload="metadata"
          [poster]="isIphone ? '../../../assets/images/ricardo.jpg' : ''">
          <source [src]="videoCaminhosPath" type="video/mp4" />
          Seu navegador não suporta o elemento de vídeo.
        </video>
        <div class="controls">
          <ion-icon name="play-outline" (click)="playVideo()">Play</ion-icon>
          <ion-icon name="pause-outline" (click)="pauseVideo()">Pause</ion-icon>
        </div>
      </div>

      <img [src]="getImagePath(1)" class="first-image" />
    </div>

    <img [src]="getImagePath(2)" />
    <img [src]="getImagePath(3)" />
    <img [src]="getImagePath(4)" />
    <img [src]="getImagePath(5)" />
    <img [src]="getImagePath(6)" />
    <img [src]="getImagePath(7)" />
    <img [src]="getImagePath(8)" />
  </div>
</ion-content>
